type TParsedPlaylist = Partial<{
  streamId: string;
  resolution: string;
  isMaster: boolean;
}>;

export const parsePlaylistUrl: (url: string) => TParsedPlaylist = (url) => {
  if (!url) {
    return {};
  }

  try {
    const urlObj: URL = new URL(url);
    const pathParts = urlObj.pathname.split('/');
    const streamId = pathParts[2];
    const fileName = pathParts[pathParts.length - 1];
    const resolution = fileName.match(/\d+_(\w+)/)?.[1] || 'source';
    const isMaster = pathParts[3] === 'master';

    return { streamId, resolution, isMaster } as TParsedPlaylist;
  } catch (e) {
    return {};
  }
};
